/**
 * Inject Cloudinary delivery transforms into an upload URL so images are
 * served resized/optimized instead of at original resolution. Non-Cloudinary
 * URLs pass through untouched.
 */
export default function cloudinaryUrl(url: string, width: number): string {
  if (!url || !url.includes('res.cloudinary.com')) return url;
  const transforms = `q_auto:best,f_auto,w_${width},c_fill,dpr_2.0`;
  return url.replace('/upload/', `/upload/${transforms}/`);
}
